import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const Card = styled.div`
  background: ${fromTheme('color_background')};
  padding: ${fromTheme('spacing_medium')};
  // remove the border unless a custom width is configured
  border-width: ${(props) =>
    fromTheme('provider_profile_border_width')(props) || '0px'};
  border-radius: ${fromTheme('provider_profile_border_radius')};
  border-style: ${fromTheme('provider_profile_border_style')};
  border-color: ${fromTheme('provider_profile_color_border')};
  box-shadow: ${fromTheme('provider_profile_box_shadow')};
  -webkit-box-shadow: ${fromTheme('provider_profile_box_shadow')};
  -moz-box-shadow: ${fromTheme('provider_profile_box_shadow')};
`;
